module.exports = __webpack_public_path__ + "img/end.b1dd04da.svg";